var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C21 5.10457 20.1046 6 19 6C18.6683 6 18.3555 5.91925 18.0801 5.77633L13.8962 9.36246C13.9635 9.5627 14 9.77709 14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 9.9863 10.0001 9.97264 10.0004 9.95901L6.4087 8.4197C6.04722 8.77841 5.54949 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5C6.10457 5 7 5.89543 7 7C7 7.0137 6.99986 7.02736 6.99959 7.04099L10.5913 8.5803C10.9528 8.22159 11.4505 8 12 8C12.3317 8 12.6445 8.08075 12.9199 8.22367L17.1038 4.63754C17.0365 4.4373 17 4.22291 17 4C17 2.89543 17.8954 2 19 2C20.1046 2 21 2.89543 21 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 8.44771 17.4477 8 18 8H20C20.5523 8 21 8.44772 21 9V19C21 19.5523 20.5523 20 20 20H18C17.4477 20 17 19.5523 17 19V9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11C3.44772 11 3 11.4477 3 12V19C3 19.5523 3.44772 20 4 20H6C6.55228 20 7 19.5523 7 19V12C7 11.4477 6.55228 11 6 11H4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14C10.4477 14 10 14.4477 10 15V19C10 19.5523 10.4477 20 11 20H13C13.5523 20 14 19.5523 14 19V15C14 14.4477 13.5523 14 13 14H11Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.25C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphAlt3);
export default __webpack_public_path__ + "static/media/graph-alt-3.5a7192397b0f27386fda946e5004ec91.svg";
export { ForwardRef as ReactComponent };